export default __webpack_public_path__ + "activate-icon.7343998975872e423bf2567857e03458.svg";